var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuguer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.976562 11.5234H24.0234C24.5628 11.5234 25 11.9606 25 12.5C25 13.0394 24.5628 13.4766 24.0234 13.4766H0.976562C0.437206 13.4766 0 13.0394 0 12.5C0 11.9606 0.437206 11.5234 0.976562 11.5234Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.976562 3.71094H24.0234C24.5628 3.71094 25 4.14814 25 4.6875C25 5.22686 24.5628 5.66406 24.0234 5.66406H0.976562C0.437206 5.66406 0 5.22686 0 4.6875C0 4.14814 0.437206 3.71094 0.976562 3.71094Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.976562 19.3359H24.0234C24.5628 19.3359 25 19.7731 25 20.3125C25 20.8519 24.5628 21.2891 24.0234 21.2891H0.976562C0.437206 21.2891 0 20.8519 0 20.3125C0 19.7731 0.437206 19.3359 0.976562 19.3359Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuguer);
export default __webpack_public_path__ + "static/media/buguer.1f498ed0.svg";
export { ForwardRef as ReactComponent };